import type {MessageDescriptor} from 'react-intl';
import type {DialerRefusal} from '../store/callSurfaceSlice';
import {dialerMessages as m} from './dialerMessages';

/**
 * The reason line under "This number isn't authorized" (boards DialerBlocked,
 * DialerPriceBlocked). The label comes from routing: a destination name such
 * as "Polish premium-rate numbers", or for the price limit a phrase such as
 * "costs more per minute than your limit of 3.00 PLN".
 */
export const refusalReason = (refusal: Pick<DialerRefusal, 'source' | 'label'>): {message: MessageDescriptor; values?: {label: string}} => {
    if (!refusal.label) return {message: m.refusedGeneric};
    if (refusal.source === 'price_limit') return {message: m.refusedPrice, values: {label: refusal.label}};
    return {message: m.refusedLabel, values: {label: refusal.label}};
};

const digits = (value: string | undefined) => (value ?? '').replace(/\D/g, '');

/** The notice belongs to the number that was refused; typing another number drops it. */
export const refusalMatches = (refusal: DialerRefusal | undefined, typed: string): refusal is DialerRefusal =>
    !!refusal && digits(refusal.number) !== '' && digits(refusal.number) === digits(typed);
